module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-picker",
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_c('div', {
    staticClass: "page-picker-wrapper"
  }, [_c('mt-picker', {
    attrs: {
      "columns": _vm.column1,
      "confirmText": "反馈",
      "showToolbar": ""
    },
    on: {
      "change": _vm.onChange1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-picker-wrapper"
  }, [_c('mt-picker', {
    attrs: {
      "columns": _vm.column2,
      "title": _vm.title2,
      "showToolbar": ""
    },
    on: {
      "confirm": _vm.onConfirm,
      "cancel": _vm.onCancel
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    },
    on: {
      "click": _vm.changeData
    }
  }, [_vm._v("点我切换数据")]), _vm._v(" "), _c('div', {
    staticClass: "page-picker-wrapper"
  }, [_c('mt-picker', {
    attrs: {
      "columns": _vm.column1,
      "title": _vm.title3,
      "showToolbar": ""
    },
    on: {
      "cancel": _vm.onCancel,
      "confirm": _vm.onConfirm
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-picker-wrapper"
  }, [_c('mt-picker', {
    attrs: {
      "columns": _vm.columns,
      "title": _vm.title4,
      "showToolbar": ""
    },
    on: {
      "change": _vm.onChange2,
      "confirm": _vm.onConfirm,
      "cancel": _vm.onCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ebd2e3e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/picker.vue
// module id = 577
// module chunks = 0